// extracted by mini-css-extract-plugin
export var section = "styles-module--section--380Nr";
export var container = "styles-module--container--MISjk";